import { apiMixin } from '@/mixins/api';
import { evtBus } from '@/main';

export const jobMixin = {
    mixins: [apiMixin],

    methods: {
        async resetJob() {
            try {
                const response = await this.requestApi('reset-job', {});
                
                if (!response.data?.token)
                    throw new Error('Token não informado');

                evtBus.$emit('evt_toast_show', {
                    title: 'Laudo resetado com sucesso',
                    description: 'Página será reiniciada em instantes',
                    variant: 'success',
                    hideDelay: 3000,
                });
                setTimeout(() => {
                    window.location.href = window.location.origin + '/?token=' + response.data.token;
                }, 300)
            } catch (error) {
                console.error('resetJobError: ', error);
                evtBus.$emit('evt_toast_show', {
                    title: 'Falha ao resetar o laudo',
                    description: error.message,
                    variant: 'error',
                    hideDelay: 6000,
                });
            }
        }   
    }
}